import { createAction } from 'Lib/reduxUtils';

import type { Photo } from 'Store/profile/user.types';

import {
  ADD_QUEUED_PHOTO,
  CLEAR_QUEUED_PHOTOS,
  COMPLETE_ONBOARDING,
  COMPLETE_ONBOARDING_ERROR,
  COMPLETE_ONBOARDING_SUCCESS,
  DELETE_ONBOARDING,
  DELETE_ONBOARDING_SUCCESS,
  FETCH_ONBOARDING_FIELDS,
  FETCH_ONBOARDING_FIELDS_ERROR,
  FETCH_ONBOARDING_FIELDS_REQUEST,
  FETCH_ONBOARDING_FIELDS_SUCCESS,
  GUEST_ONBOARDING_INIT,
  ONBOARDING_INIT,
  ONBOARDING_SPARKS,
  REMOVE_QUEUED_PHOTO,
  RESET_ONBOARDING_COMPLETION_STATUS,
  SET_ONBOARDING_ERRORS,
  SET_ONBOARDING_FIELDS,
  SET_ONBOARDING_STEP,
  SET_ONBOARDING_STEPS,
  UPDATE_ONBOARDING_FIELDS,
  UPDATE_ONBOARDING_FIELDS_ERROR,
  UPDATE_ONBOARDING_FIELDS_REQUEST,
  UPDATE_ONBOARDING_FIELDS_SUCCESS,
  UPDATE_QUEUED_PHOTOS_ORDER,
} from './constants';

export const deleteOnboarding = createAction(DELETE_ONBOARDING, (data: any) => data);
export const deleteOnboardingSuccess = createAction(DELETE_ONBOARDING_SUCCESS);
export const completeOnboarding = createAction(COMPLETE_ONBOARDING);
export const completeOnboardingSuccess = createAction(COMPLETE_ONBOARDING_SUCCESS);
export const completeOnboardingError = createAction(COMPLETE_ONBOARDING_ERROR);

// This is used for AV post-onboarding modal
export const resetOnboardingCompletionStatus = createAction(RESET_ONBOARDING_COMPLETION_STATUS);

export const fetchOnboardingFields = createAction(FETCH_ONBOARDING_FIELDS);
export const fetchOnboardingFieldsRequest = createAction(FETCH_ONBOARDING_FIELDS_REQUEST);
export const fetchOnboardingFieldsSuccess = createAction(
  FETCH_ONBOARDING_FIELDS_SUCCESS,
  ({ result }: any) => ({ result })
);
export const fetchOnboardingFieldsError = createAction(
  FETCH_ONBOARDING_FIELDS_ERROR,
  (error: any) => error
);

export const setOnboardingErrors = createAction(SET_ONBOARDING_ERRORS, (errors: any) => ({
  errors,
}));

export const setOnboardingFields = createAction(
  SET_ONBOARDING_FIELDS,
  (values: Record<string, any>) => ({ values })
);

export const updateOnboardingFields = createAction(
  UPDATE_ONBOARDING_FIELDS,
  (
    values: Record<string, any>,
    isSubmission: boolean = false,
    sparksEventValue?: Record<string, any>
  ) => ({ values, isSubmission, sparksEventValue })
);
export const updateOnboardingFieldsRequest = createAction(UPDATE_ONBOARDING_FIELDS_REQUEST);
export const updateOnboardingFieldsSuccess = createAction(
  UPDATE_ONBOARDING_FIELDS_SUCCESS,
  ({ result }: any) => ({ result })
);
export const updateOnboardingFieldsError = createAction(
  UPDATE_ONBOARDING_FIELDS_ERROR,
  (fieldName: string, error: any) => ({ fieldName, error })
);

export const setOnboardingStep = createAction(SET_ONBOARDING_STEP, (currentStep: string) => ({
  currentStep,
}));

export const setOnboardingSteps = createAction(
  SET_ONBOARDING_STEPS,
  (steps: string[], currentStep: string) => ({
    currentStep,
    steps,
  })
);

export const onboardingInit = createAction(ONBOARDING_INIT);

export const guestOnboardingInit = createAction(GUEST_ONBOARDING_INIT);

export const onboardingSparks = createAction(
  ONBOARDING_SPARKS,
  (fields: Record<string, any>, action: string = 'view', success: boolean = action !== 'view') => ({
    action,
    fields,
    success,
  })
);

export const addQueuedPhoto = createAction(ADD_QUEUED_PHOTO, (photo: Photo) => photo);

export const removeQueuedPhoto = createAction(REMOVE_QUEUED_PHOTO, (id: string) => id);

export const clearQueuedPhotos = createAction(CLEAR_QUEUED_PHOTOS);

export const updateQueuedPhotosOrder = createAction(
  UPDATE_QUEUED_PHOTOS_ORDER,
  (order: string[]) => order
);
